import { createPropertySelectors } from '@ngxs/store'
import { CrossSectionState, CrossSectionStateModel } from './cross-section.state'

export class CrossSectionStateSelectors {
  static slices = createPropertySelectors<CrossSectionStateModel>(CrossSectionState)
}
